import { URLS } from '../constants'
import { dispatchFetchGet } from './ActionsUtil'
import {
    GET_ALL_LOGS_BEGIN, GET_ALL_LOGS_SUCCESS, GET_ALL_LOGS_FAILURE
} from '../constants/ActionTypes'

const acGetAllLogsBegin = () => ({ type: GET_ALL_LOGS_BEGIN })
const acGetAllLogsSuccess = payload => ({ type: GET_ALL_LOGS_SUCCESS, payload: { response: payload } })
const acGetAllLogsFailure = err => ({ type: GET_ALL_LOGS_FAILURE, payload: err })

export const acGetAllLogsByManagerId = (managerEmail) => {
    return dispatchFetchGet(
        `${URLS.MANAGER_LOG.MANAGER_EMAIL}?email=${managerEmail}`,
        acGetAllLogsBegin,
        acGetAllLogsSuccess,
        acGetAllLogsFailure
    )
}

export const acGetAllLogsByActionClass = (actionClass) => {
    return dispatchFetchGet(
        `${URLS.MANAGER_LOG.ACTION_CLASS}?actionClass=${actionClass}`,
        acGetAllLogsBegin,
        acGetAllLogsSuccess,
        acGetAllLogsFailure
    )
}

export const acGetAllLogsByAction = (action) => {
    return dispatchFetchGet(
        `${URLS.MANAGER_LOG.ACTION}?action=${action}`,
        acGetAllLogsBegin,
        acGetAllLogsSuccess,
        acGetAllLogsFailure
    )
}

export const acGetAllLogsByMonth = (month) => {
    return dispatchFetchGet(
        `${URLS.MANAGER_LOG.MONTH}?month=${month}`,
        acGetAllLogsBegin,
        acGetAllLogsSuccess,
        acGetAllLogsFailure
    )
}